"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ContentTile = void 0;

var react_1 = __importDefault(require("react"));

require("./template-1-content-tile.css");

var prop_types_1 = __importDefault(require("prop-types"));

var check_svg_1 = __importDefault(require("./check.svg"));

function ContentTile(_ref) {
  var title = _ref.title,
      description = _ref.description,
      icon = _ref.icon;
  return react_1.default.createElement("div", {
    className: "h-auto px-10 py-16 swapper"
  }, react_1.default.createElement("div", {
    className: "items-center justify-center w-12 h-12 bg-black rounded-none swapper-icon grid"
  }, react_1.default.createElement("img", {
    src: icon,
    alt: ""
  })), react_1.default.createElement("div", {
    className: "text-2xl not-italic font-medium tracking-normal text-left mt-14 leading-7"
  }, title), react_1.default.createElement("div", {
    className: "mt-5 text-base not-italic font-normal tracking-normal text-left leading-6"
  }, description));
}

exports.ContentTile = ContentTile;
ContentTile.propTypes = {
  title: prop_types_1.default.string,
  icon: prop_types_1.default.element,
  description: prop_types_1.default.string
};
ContentTile.defaultProps = {
  icon: check_svg_1.default,
  title: 'Save your time',
  description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nisi at proin massa potenti eget vulputate massa dui.'
};